import { createAsyncThunk } from 'legacy/lut/store/utils/createAsyncThunk'

import { fetchCompetitorsSob } from '../../../services/competitorsSob/fetchCompetitorsSob'
import { REQUEST_COMPETITORS_SOB } from '../constants'
import { selectCompetitorsSobState } from '../selectors/selectCompetitorsSobState'

export const requestCompetitorsSob = createAsyncThunk(
  REQUEST_COMPETITORS_SOB,
  fetchCompetitorsSob,
  {
    condition({ partnerId, fYear, programType }, { getState }) {
      if (!partnerId || !fYear || !programType) {
        return false
      }

      const state = getState()
      const competitorsState = selectCompetitorsSobState(state)

      if (
        competitorsState.fYear === fYear &&
        competitorsState.partnerId === partnerId &&
        competitorsState.data[programType]?.length
      ) {
        return false
      }

      return true
    },
  }
)
